// @ vendors
const Immutable = require('immutable');
const Moment = require('moment');
// @ constants
const actionTypes = require('../loansConstants/actionTypes');
const { EURO_TEXT,
        DATE_FILTER_NONE, TRANSFER_MIN_IMPORT } = require('constants/index');
//@reducers
const loanMovementsDetailsReducer = require('./loans/loanMovementsDetails');
//@helper
const { hash } = require('utilities/hash');
const trim = require('lodash/string/trim');
const get = require('lodash/object/get');

const filtersInitialState = Immutable.fromJS({
    date: {
        isActive: false,
        from: Moment().subtract(5, 'years'),
        to: Moment(),
        selected: DATE_FILTER_NONE

    },
    amount: {
        isActive: false,
        from: {
            amount: null
        },
        to: {
            amount: null
        }
    }
});

const initialState = Immutable.fromJS({
    byOrder: [],
    byId: {},
    isFetching: false,
    error: '',
    filters: filtersInitialState,
    isFetchingNextPage: false
});

function setFilters(filters) {
    const hasDateFilter = get(filters, 'date.selected') !== DATE_FILTER_NONE;
    const hasAmountFilters = (get(filters, 'amount.from.amount') !== null && get(filters, 'amount.from.amount') !== TRANSFER_MIN_IMPORT) ||
        (get(filters, 'amount.to.amount') !== null && get(filters, 'amount.to.amount') !== TRANSFER_MIN_IMPORT);
    if (!hasDateFilter) {
        // jorge.zapata: If there is no date filter ('Todos' option is selected), we set the initial state date filter
        // to current filter in order to avoid empty 'from' and 'to' date values in following validations
        filters.date = filtersInitialState.get('date').toJS();
    }
    if (filters.date) {
        filters.date.isActive = hasDateFilter;
    }
    if (filters.amount) {
        filters.amount.isActive = hasAmountFilters;
    }
    return Immutable.fromJS(filters);
}

function mapFields(movements, loanId, productCode) {
    const byId = {};
    const byOrder = [];

    movements.forEach((movement) => {
        const id = hash(trim(get(movement, 'fechaMovimiento')) + trim(get(movement, 'importe.importe')) + trim(get(movement, 'saldo.importe')));

        byId[id] = {
            id,
            loanId,
            productCode,
            movementDate: get(movement, 'fechaMovimiento'),
            valueDate: get(movement, 'fechaValor'),
            description: get(movement, 'descripcion', ''),
            amount: {
                amount: get(movement, 'importe.importe', 0),
                currency: get(movement, 'importe.divisa', EURO_TEXT)
            },
            capital: {
                amount: get(movement, 'saldo.importe', 0),
                currency: get(movement, 'saldo.divisa', EURO_TEXT)
            },
            operationSequenceNumber: get(movement, 'numeroSecuenciaOperacion', 0),
            DGOOperation: {
                center: get(movement, 'operacionDGO.centro', ''),
                dgoTerminalCode: get(movement, 'operacionDGO.codigoterminaldgo', ''),
                dgoNumber: get(movement, 'operacionDGO.numerodgo', '')
            },
            bankOperation: {
                basicOperation: get(movement, 'operacionBancaria.operacionbasica', ''),
                bankOperation: get(movement, 'operacionBancaria.operacionbancaria', '')
            },
            details: loanMovementsDetailsReducer(undefined, {type: null})
        }

        byOrder.push(id);
    });

    return {
        byOrder,
        byId
    }
}

function loanMovementsReducer(state = initialState, action) {
    let processedMovements;
    switch (action.type) {
        case actionTypes.FETCH_LOAN_MOVEMENTS_REQUEST:
            return state.mergeDeep({
                isFetching: true,
                error: false,
                byId: null,
                byOrder: null,
                nextPage: null
            });
        case actionTypes.FETCH_LOAN_MOVEMENTS_SUCCESS:
            processedMovements = mapFields(action.payload.movements, action.payload.loanId, action.payload.productCode);
            return state.mergeDeep({
                byId: processedMovements.byId,
                byOrder: processedMovements.byOrder,
                isFetching: false,
                error: false,
                nextPage: action.payload.nextPage
            });
        case actionTypes.FETCH_LOAN_MOVEMENTS_FAILURE:
            return state.mergeDeep({
                isFetching: false,
                error: action.payload.error
            });
        case actionTypes.FETCH_LOAN_MOVEMENTS_DETAILS:
        case actionTypes.FETCH_LOAN_MOVEMENTS_DETAILS_SUCCESS:
        case actionTypes.FETCH_LOAN_MOVEMENTS_DETAILS_FAILURE:
            const path = ['byId', action.payload.movementId, 'details'];
            return state.setIn(path, loanMovementsDetailsReducer(state.getIn(path), action));
        case actionTypes.SET_LOAN_MOVEMENTS_FILTERS:
            return state.set('filters', setFilters(action.payload.filters));
        case actionTypes.RESET_LOAN_MOVEMENTS_FILTER:
            const { filter } = action.payload;
            return state.setIn(['filters', filter], initialState.getIn(['filters', filter]));
        case actionTypes.CLEAR_LOAN_MOVEMENTS_FILTERS:
            return state.set('filters', filtersInitialState);
        case actionTypes.LOAN_MOVEMENTS_FETCH_NEXT_PAGE:
            return state.set('isFetchingNextPage', true);
        case actionTypes.LOAN_MOVEMENTS_FETCH_NEXT_PAGE_SUCCESS:
            const { movements, loanId, nextPage, productCode } = action.payload;
            processedMovements = mapFields(movements, loanId, productCode);

            return state.mergeDeep({
                byId: processedMovements.byId,
                byOrder: state.get('byOrder').concat(Immutable.fromJS(processedMovements.byOrder)),
                isFetchingNextPage: false,
                error: false,
                nextPage: nextPage
            });
        case actionTypes.LOAN_MOVEMENTS_FETCH_NEXT_PAGE_FAILURE:
            return state.mergeDeep({
                isFetchingNextPage: false,
                error: action.payload.error
            });
        default:
            return state;
    }
}

module.exports = loanMovementsReducer;
